module.exports = __webpack_public_path__ + "img/bgTitle2.7bcba0bb.png";